/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import PropTypes from "prop-types";
import { TiPencil } from "react-icons/ti";

const FilterRecapChip = ({ value, ...props }) => (
  <div
    // onClick={() => dispatch(setFiltersPopupOpened(true))}
    {...props}
    className="p-1.5 bg-gray-500 md:bg-gray-400 hover:bg-gray-500 text-xs md:text-xxs text-white md:py-0 px-3 space-x-2 rounded-full cursor-pointer flex items-center transition-all duration-75"
  >
    <span>{value}</span>
    <TiPencil />
  </div>
);

FilterRecapChip.propTypes = {
  value: PropTypes.string
};

FilterRecapChip.defaultProps = {
  value: ""
};

export default FilterRecapChip;
